"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var isInteger_1 = tslib_1.__importDefault(require("lodash/isInteger"));
var range_1 = tslib_1.__importDefault(require("lodash/range"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var ModuleHeader_1 = tslib_1.__importDefault(require("../moduleHeader/ModuleHeader"));
var BannerContent_1 = tslib_1.__importDefault(require("../_common/bannerContent/BannerContent"));
var WidgetContainer_1 = tslib_1.__importDefault(require("../_common/WidgetContainer"));
var BannerWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    margin-left: -15px;\n    margin-bottom: -15px;\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n    margin-left: -15px;\n    margin-bottom: -15px;\n"])));
var BannerGroup = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    display: flex;\n    margin-left: -15px;\n\n    ", " {\n        flex: 1;\n        padding-left: 15px;\n    }\n"], ["\n    display: flex;\n    margin-left: -15px;\n\n    ", " {\n        flex: 1;\n        padding-left: 15px;\n    }\n"])), BannerWrapper);
var BannerContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n    padding-left: 15px;\n    padding-bottom: 15px;\n    flex: 1;\n    box-sizing: border-box;\n"], ["\n    padding-left: 15px;\n    padding-bottom: 15px;\n    flex: 1;\n    box-sizing: border-box;\n"])));
var BannerModuleGroup = function (_a) {
    var apiLocale = _a.apiLocale, cdnTemplate = _a.cdnTemplate, isoLocale = _a.isoLocale, moduleData = _a.moduleData, tracking = _a.tracking;
    console.log('#TODO: USE ME', cdnTemplate);
    var banners = moduleData.banners, moduleHeader = moduleData.moduleHeader, textColor = moduleData.textColor;
    var innerSpacingValues = range_1.default(0, 20, 5);
    // SET PADDING SIZE AND SPACING LAYOUT FOR GROUPED BANNERS
    var paddingForGroupedBanners = function (groupedBanners) {
        // DEFAULT 15px. ie: 3rd in innerSpacingValues
        var innerSpacing = moduleData && {}.hasOwnProperty.call(moduleData, 'innerSpacing') ? moduleData.innerSpacing : null;
        // DEFAULT 15px. ie: 3rd in innerSpacingValues
        var innerSpacingLayout = moduleData && 'innerSpacingLayout' in moduleData ? moduleData.innerSpacingLayout : null;
        var groupedBannerCount = groupedBanners.length;
        var customPadding = [];
        if (!isInteger_1.default(innerSpacing) && !isInteger_1.default(innerSpacingLayout)) {
            return [];
        }
        var paddingPx = innerSpacing && innerSpacingValues[innerSpacing] ? innerSpacingValues[innerSpacing] : 15;
        groupedBanners.forEach(function (_, index) {
            switch (innerSpacingLayout) {
                case 1:
                    // Right padding for 1st and 3rd, others none.
                    // Main vertical split
                    customPadding[index] =
                        index % (groupedBannerCount / 2) === 0 ? "0px " + paddingPx + "px 0px 0px" : "0px 0px 0px 0px";
                    break;
                case 2:
                    // Bottom padding for 1st and 2nd, others none.
                    // Main horizontal split
                    customPadding[index] =
                        index < groupedBannerCount / 2 ? "0px 0px " + paddingPx + "px 0px" : "0px 0px 0px 0px";
                    break;
                case 3:
                    // Bottom and right padding for 1st and 2nd, others none.
                    // Main horizontal split + vertical split between 1,2
                    customPadding[index] =
                        index < groupedBannerCount / 2 ? "0px 0px " + paddingPx + "px " + paddingPx + "px" : "0px 0px 0px 0px";
                    break;
                case 4:
                    // Top and left padding for 3rd, left padding for the rest
                    // Main vertical split + horizontal split between 1,3
                    customPadding[index] =
                        index % groupedBannerCount === 2
                            ? paddingPx + "px 0px 0px " + paddingPx + "px"
                            : "0px 0px 0px " + paddingPx + "px";
                    break;
                case 5:
                    // Top and left padding for 4th, right padding for the rest
                    // Main vertical split + horizontal split between 1,3
                    customPadding[index] =
                        index % groupedBannerCount === 3
                            ? paddingPx + "px 0px 0px " + paddingPx + "px"
                            : "0px 0px 0px " + paddingPx + "px";
                    break;
                default:
                    // Set default padding layout for the given size
                    customPadding[index] = "0px 0px " + paddingPx + "px " + paddingPx + "px";
            }
        });
        return customPadding;
    };
    var supportBanners = banners.slice(1);
    var paddingStyles = paddingForGroupedBanners(supportBanners);
    return (react_1.default.createElement(WidgetContainer_1.default, { bgColor: moduleData.bgColor, bgImage: moduleData.bgImage },
        react_1.default.createElement("div", null,
            moduleHeader && (react_1.default.createElement(ModuleHeader_1.default, { className: "siteWidthContainer", moduleData: moduleHeader, textColor: textColor })),
            Array.isArray(banners) && (react_1.default.createElement(BannerGroup, null,
                react_1.default.createElement(BannerWrapper, null,
                    react_1.default.createElement(BannerContainer, null,
                        react_1.default.createElement(BannerContent_1.default, { bannerData: banners[0], tracking: tracking, isoLocale: isoLocale, apiLocale: apiLocale }))),
                react_1.default.createElement(BannerWrapper, null, supportBanners.map(function (banner, index) {
                    return (react_1.default.createElement(BannerContainer, { key: banner.assetId || '', style: { padding: paddingStyles[index], flex: '0 0 50%' } },
                        react_1.default.createElement(BannerContent_1.default, { bannerStyle: "bgImage", bannerData: banner, isoLocale: isoLocale, tracking: tracking, apiLocale: apiLocale })));
                })))))));
};
exports.default = react_1.default.memo(BannerModuleGroup);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=BannerModuleGroup.js.map